var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "well ovx-auto" }, [
    _c(
      "ul",
      { staticClass: "kpi-list list-inline acenter" },
      _vm._l(_vm.kpis, function(kpi) {
        return _c("li", { key: kpi.name, staticClass: "kpi" }, [
          _c("div", { staticClass: "kpi-label", attrs: { tips: kpi.tips } }, [
            _vm._v(_vm._s(kpi.title))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "kpi-value" }, [
            _vm._v(_vm._s(kpi.formatted))
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }